export default __webpack_public_path__ + "static/media/JP1-2.db9e14c2.jpg";